import * as React from "react";
import styles from "@styles/pages/about-us/index.module.scss";
import Image from "next/image";
import Link from "next/link";
import {useRef} from "react";
import {useInView} from "framer-motion";
import {strapi} from "@api/Strapi";

// @ts-ignore
function AboutUs({AboutUsList}) {

    // these variables are used to animate the left and right image when this view are on screen.
    const ref = useRef(null);
    const isInView = useInView(ref, {once: false});

    /***
     * This page includes the header and footer components
     * top section contain banner, after that the description of the company with story, brand and team.
     * after that contain about the culture section in that we have giving back, innovation and people details,
     * the last section have the details about the customer care and contain the email.
     */
    return (
        <>
            <section className={styles.banner}>
                <Image src={'/assets/images/banners/about_us/about_us_banner_d.webp'} alt={'about us banner'}
                       fill={true}></Image>
                <div className={'details_container'}>
                    <div className={'sidr_text'}>sidr</div>
                    <h1 className={'title_text'}>hive to home</h1>
                    <div className={'description'}>is to produce the finest honey products, and continuous development
                        while maintaining our integrity and ethics.
                    </div>
                </div>
            </section>
            <section className={styles.container}>
                <div className={'details'}>
                    <span className={'title_light'}>happens</span>
                    <h2 className={'title_bold'}>with honey</h2>
                    <p>
                        At SIDR, our primary focus is on the Food and Consumer with a mission bringing diversified,
                        high-quality, nutritious food products creating transformational experiences for people to live
                        happy, healthy, fun lives — over and over again.
                    </p>
                </div>
                <hr/>
                <div className={'about_us_list'}>
                    {
                        AboutUsList.map((about: any, index: string) => {
                            return (<div key={'details-' + index} className={'item'}>
                                <img src={about.attributes.Image.data.attributes.url}
                                     alt={about.attributes.Image.data.attributes.alternativeText}/>
                                <div className={'container_detail'}>
                                    <div className={'content'}>
                                        <span>{about.attributes.Sub_Title}</span>
                                        <span className={'title_bold'}>{about.attributes.Title}</span>
                                        <p>{about.attributes.Description}</p>
                                    </div>
                                </div>
                            </div>)
                        })
                    }
                </div>
                <hr/>
                <div className={'our_culture'}>
                    <span className={'main_title'}>our culture</span>
                    <div className={'container'}>
                        <div>
                            <img
                                src={'/assets/images/decorations/about_us/about_us_page_our_culture_giving_back.webp'} alt={'giving back'}/>
                            <span className={'title'}>giving back</span>
                            <p className={'description'}>
                                Adopting limitless innovation to bring about plentiful supply for generations to come.
                                The future of food security tomorrow begins with the seeds of innovation today.
                            </p>
                            <Link className={'learn_more'} href={'/impact'}>
                                <span>know more</span>
                            </Link>
                        </div>
                        <div>
                            <img src={'/assets/images/decorations/about_us/about_us_page_our_culture_innovation.webp'} alt={'innovation'}/>
                            <span className={'title'}>innovation</span>
                            <p className={'description innovation'}>
                                SIDR believes in nonstop innovation that results in nutritious food, the finest products
                                for accessible to everyone, while supporting and caring for our people and communities
                                near and far.
                            </p>
                            <Link className={'learn_more'} href={'/innovation'}>
                                <span>know more</span>
                            </Link>
                        </div>
                        <div>
                            <img src={'/assets/images/decorations/about_us/about_us_page_our_culture_people.webp'} alt={'people'}/>
                            <span className={'title'}>people</span>
                            <p className={'description people'}>
                                A job at SIDR is a chance to live in the “brighter future” that we are now developing,
                                an opportunity of unprecedented scope for transformational experiences for people to
                                live happy, healthy, and fun lives.
                            </p>
                            <Link className={'learn_more'} href={'/be-part-of-sidr'}>
                                <span>know more</span>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className={'consumer_care'} ref={ref}>
                    <div className={`images ${isInView ? 'image_animation' : ''}`}>
                        <img className={'desktop'}
                             src="/assets/images/decorations/about_us/about_us_page_consumer_care_left.webp"
                             alt="image"/>
                        <img className={'desktop'}
                             src="/assets/images/decorations/about_us/about_us_page_consumer_care_right.webp"
                             alt="image"/>
                        <img className={'ipad'}
                             src="/assets/images/decorations/about_us/about_us_consumer_care_ipad_left.webp"
                             alt="image"/>
                        <img className={'ipad'}
                             src="/assets/images/decorations/about_us/about_us_consumer_care_ipad_right.webp"
                             alt="image"/>
                        <img className={'mobile'}
                             src="/assets/images/decorations/about_us/about_us_consumer_care_mobile_left.webp"
                             alt="image"/>
                        <img className={'mobile'}
                             src="/assets/images/decorations/about_us/about_us_consumer_care_mobile_right.webp"
                             alt="image"/>
                    </div>
                    <span>
                        looking for sidr consumer care?
                    </span>
                    <div className={'description'}
                         dangerouslySetInnerHTML={{__html: 'For information on all our products, please email SIDR Consumer Care at <a href="mailto:care@sidr.com">care@sidr.com</a>'}}></div>
                </div>
            </section>
        </>
    )
}

export async function getServerSideProps(context: any) {

    const seoDetails = {
        // title: `About | SIDR®`,
        url: context.resolvedUrl,
        // keyword: 'honey producer',
        // description: 'At SIDR®, our vision is to become an innovative, world-class honey producer that is recognized for being a reliable partner.'
    }

    try {
        const response = await strapi.getAboutUs();
        if (response.status == 200 && response.data && response.data.data) {
            return {props: {AboutUsList: response.data.data, seoDetails}}
        }
        return {props: {AboutUsList: [], seoDetails}}
    } catch (e) {
        console.log(e)
        return {props: {AboutUsList: [], seoDetails}}
    }
}

export default AboutUs;
